import LegalLayout from "./LegalLayout";
import { Mail, MapPin, Clock, ShieldAlert, CreditCard, MessageCircle } from "lucide-react";

const CONTACTS = [
  { icon: Mail, label: "General enquiries", value: "hello@anubandh.ai", href: "mailto:hello@anubandh.ai", testid: "contact-hello" },
  { icon: CreditCard, label: "Billing & refunds", value: "billing@anubandh.ai", href: "mailto:billing@anubandh.ai", testid: "contact-billing" },
  { icon: ShieldAlert, label: "Privacy / DPO", value: "privacy@anubandh.ai", href: "mailto:privacy@anubandh.ai", testid: "contact-privacy" },
  { icon: MessageCircle, label: "Grievance officer", value: "grievance@anubandh.ai", href: "mailto:grievance@anubandh.ai", testid: "contact-grievance" },
];

export default function Contact() {
  return (
    <LegalLayout title="Contact Us" updated="10 February 2026">
      <p>
        We take user relationships seriously — because that&apos;s literally what we&apos;re building.
        Below are the direct channels for reaching Anubandh AI. Every email is read by a real
        human, not a bot.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">Reach the right team, faster</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
        {CONTACTS.map((c) => {
          const Icon = c.icon;
          return (
            <a
              key={c.testid}
              href={c.href}
              data-testid={c.testid}
              className="border border-stone-200 rounded-2xl bg-white p-5 hover:border-amber-300 hover:bg-amber-50/40 transition-colors flex items-start gap-3"
            >
              <div className="w-9 h-9 rounded-full bg-amber-50 border border-amber-200 grid place-items-center shrink-0">
                <Icon size={16} className="text-amber-700" />
              </div>
              <div className="min-w-0">
                <div className="text-xs uppercase tracking-widest text-stone-500">{c.label}</div>
                <div className="mt-1 font-medium text-[#1E1B4B] text-sm truncate">{c.value}</div>
              </div>
            </a>
          );
        })}
      </div>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-10">Registered Office</h2>
      <div className="mt-3 border border-stone-200 rounded-2xl bg-white p-5 flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-amber-50 border border-amber-200 grid place-items-center shrink-0">
          <MapPin size={16} className="text-amber-700" />
        </div>
        <div className="text-sm text-stone-700 leading-relaxed">
          <div className="font-medium text-[#1E1B4B]">Anubandh.ai</div>
          <div>Tower A2-1206, Supertech Livingston</div>
          <div>Crossing Republic, Near Gaur Chowk</div>
          <div>Greater Noida, District Ghaziabad (UP) – 201016</div>
          <div>India</div>
          <div className="text-xs text-stone-500 mt-2">
            Registered office · For legal &amp; regulatory correspondence.
          </div>
        </div>
      </div>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-10">Response Times</h2>
      <div className="mt-3 border border-stone-200 rounded-2xl bg-white p-5 flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-amber-50 border border-amber-200 grid place-items-center shrink-0">
          <Clock size={16} className="text-amber-700" />
        </div>
        <ul className="text-sm text-stone-700 space-y-1.5">
          <li>Billing &amp; account issues — <strong>within 48 hours</strong> (Mon–Fri)</li>
          <li>Privacy / DPDP data requests — <strong>within 72 hours</strong> acknowledgement</li>
          <li>Grievance officer resolutions — <strong>within 15 days</strong> per IT Rules 2021</li>
          <li>General enquiries — <strong>within 3 business days</strong></li>
        </ul>
      </div>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-10">Grievance Officer</h2>
      <p>
        Appointed per Rule 3(2) of the IT (Intermediary Guidelines and Digital Media Ethics Code)
        Rules, 2021:
      </p>
      <ul className="list-none pl-0 space-y-1">
        <li><strong>Name:</strong> K. Singh</li>
        <li><strong>Designation:</strong> Founder &amp; Grievance Officer</li>
        <li><strong>Email:</strong> <a className="text-amber-700 underline" href="mailto:grievance@anubandh.ai">grievance@anubandh.ai</a></li>
        <li><strong>Working hours:</strong> Monday to Friday, 10:30 AM – 6:00 PM IST</li>
      </ul>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-10">A note from the team</h2>
      <p className="italic text-stone-600">
        &quot;We are building Anubandh AI because we watched too many good people marry into
        confusion. If you have feedback — a bug, a poem, a testimonial, or a hard question — we
        want to hear it. Every message shapes what we build next.&quot;
      </p>

      <div className="mt-10 pt-6 border-t border-stone-200 text-xs text-stone-500">
        For press &amp; partnerships, please reach out to hello@anubandh.ai with the subject line
        &quot;Press&quot; or &quot;Partnership&quot;.
      </div>
    </LegalLayout>
  );
}
